import React from 'react';
import { tailwindOverride } from '@getsynapse/design-system';
import { Icon } from '@getsynapse/design-system';
import { KPIChartProps } from '../chartBuilder';
import { formatNumberAbbreviated } from '../../../utils/formatters';

export const GenericKPIChart: React.FC<KPIChartProps> = ({ chartData }) => {
  return (
    <div className='flex gap-x-4 items-center h-full p-4'>
      <div className='text-center'>
        <span
          className='text-6xl font-bold cursor-help'
          title={(chartData.value || 0).toLocaleString()}
        >
          {formatNumberAbbreviated(chartData.value || 0)}
        </span>
        <br />
        <small
          className={tailwindOverride('font-bold whitespace-nowrap', {
            'text-error': chartData.trend <= 0,
            'text-teal-green': chartData.trend > 0,
          })}
        >
          <span className='text-xs'>
            {chartData.trend > 0 ? (
              <Icon name='caret-up' />
            ) : (
              <Icon name='caret-down' />
            )}
          </span>
          {Intl.NumberFormat('en-US', {
            style: chartData.trendIsPercent ? 'percent' : 'decimal',
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
          }).format(
            Math.abs(
              (chartData.trend || 0) / (chartData.trendIsPercent ? 100 : 1)
            )
          )}
        </small>
      </div>
      <p className=''>{chartData.description}</p>
    </div>
  );
};

export default GenericKPIChart;
